<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn id="btn-voltar-atendimentos" color="primary" x-small text @click="$goBack()">
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          Diário de Auxiliares — Relatórios Diários
        </h1>
      </v-col>
    </v-row>

    <!-- Cabeçalho no mesmo formato do Diário Online: dados do vínculo, contagens por
         situação e a barra de documentos logo abaixo. -->
    <v-card v-if="gestao">
      <v-card-text>
        <v-row style="color: black">
          <v-col cols="12">
            <h4>Aluno: {{ nomeDoAluno }}</h4>
            <h4>Turma: {{ gestao.turma ? gestao.turma.descricao : "- - -" }}</h4>
            <h4>Total de atendimentos: {{ paginate.total || 0 }}</h4>
            <div>
              <v-row>
                <v-col cols="12" md="5">
                  <h4>Professor (a): {{ gestao.professor ? gestao.professor.nome : "- - -" }}</h4>
                </v-col>
                <v-col cols="12" md="7">
                  <v-avatar color="indigo" size="25" class="ms-3">
                    <v-icon dark> mdi-account-circle </v-icon>
                  </v-avatar>
                  <v-chip class="ms-3" small color="primary darken-2">
                    Atendimentos confirmados: {{ totais.confirmados }}
                  </v-chip>
                  <v-chip class="ms-3" small color="primary lighten-1">
                    Atendimentos aguardando confirmação: {{ totais.aguardando }}
                  </v-chip>
                </v-col>
              </v-row>
            </div>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" class="py-2">
            <!-- Cenário 6: só estes dois documentos nesta tela -->
            <v-btn-toggle borderless>
              <v-btn id="btn-documento-atendimentos" @click="dialogMes = true">
                <span class="hidden-sm-and-down">Atendimentos</span>
                <v-icon right> mdi-file-pdf </v-icon>
              </v-btn>

              <v-btn id="btn-historico-atendimentos" @click="abrirHistorico">
                <span class="hidden-sm-and-down">Histórico de atendimentos</span>
                <v-icon right> mdi-poll </v-icon>
              </v-btn>
            </v-btn-toggle>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-row>
      <v-col cols="12" class="pt-6">
        <v-btn id="btn-criar-atendimento" color="success" @click="criarAtendimento">
          Criar novo atendimento
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col class="pt-0">
        <v-data-table
          :headers="table.headers"
          :items="atendimentos"
          :loading="carregando"
          hide-default-footer
          :items-per-page="10"
          no-data-text="Não há atendimentos lançados para este vínculo."
          class="elevation-1"
        >
          <template v-slot:body="{ items }">
            <tbody>
              <tr v-for="atendimento of items" :key="atendimento.id">
                <td>{{ atendimento.id }}</td>
                <td>{{ atendimento.data_formatada }}</td>
                <td>
                  <e-situacao-atendimento
                    :atendimento="atendimento"
                    :gestao-id="gestaoId"
                    @alterado="listarAtendimentos(pageNumber)"
                  />
                </td>
                <td>{{ atendimento.tipo_de_atendimento }}</td>
                <td>
                  <div class="d-flex align-center">
                    <v-icon small color="grey" class="mr-2">mdi-clock-outline</v-icon>
                    {{ atendimento.descricaoHorario }}
                  </div>
                </td>
                <td class="text-left text-nowrap">
                  <v-btn
                    :id="`btn-visualizar-atendimento-${atendimento.id}`"
                    x-small
                    class="ml-1"
                    color="primary"
                    @click="visualizarAtendimento(atendimento)"
                  >
                    <v-icon small>fa fa-eye</v-icon>
                  </v-btn>
                  <!-- Como no Diário Online: só edita enquanto aguarda confirmação ou
                       está em conflito. -->
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <div class="d-inline-block ml-1" v-bind="attrs" v-on="on">
                        <v-btn
                          :id="`btn-editar-atendimento-${atendimento.id}`"
                          x-small
                          color="blue"
                          :disabled="!podeEditar(atendimento)"
                          @click="editarAtendimento(atendimento)"
                        >
                          <v-icon small>fa fa-edit</v-icon>
                        </v-btn>
                      </div>
                    </template>
                    <span>
                      {{
                        podeEditar(atendimento)
                          ? "Editar atendimento"
                          : atendimento.descricaoSituacao + " não pode ser editado"
                      }}
                    </span>
                  </v-tooltip>
                  <v-btn
                    :id="`btn-apagar-atendimento-${atendimento.id}`"
                    x-small
                    class="ml-1"
                    color="error"
                    @click="apagarAtendimento(atendimento)"
                  >
                    <v-icon small>fa fa-trash</v-icon>
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>

        <e-paginate
          :current_page="paginate.current_page"
          :last_page="paginate.last_page"
          :pageNumber="pageNumber"
          @changeActionResponse="listarAtendimentos"
        />
      </v-col>
    </v-row>

    <!-- Documento Atendimentos: por mês (Cenário 7) -->
    <v-dialog v-model="dialogMes" persistent width="480">
      <v-card>
        <v-card-title class="text-h6 primary white--text">Documento de Atendimentos</v-card-title>
        <e-autocomplete
          id="select-mes-documento"
          class="mx-2 mt-4"
          :items="meses"
          :return-object="false"
          :item-value="(value) => value.id"
          :item-text="(value) => value.descricao"
          v-model="mesSelecionado"
          label="Selecione o mês"
        />
        <v-card-actions>
          <v-spacer />
          <v-btn id="btn-fechar-modal-mes" color="red" text @click="dialogMes = false">
            Fechar
          </v-btn>
          <v-btn
            id="btn-gerar-documento-atendimentos"
            color="primary"
            text
            :disabled="!mesSelecionado"
            @click="gerarDocumentoDeAtendimentos"
          >
            Gerar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Histórico de Atendimentos (Cenário 6) -->
    <e-drawer-historico-atendimentos v-model="drawerHistorico" :gestao-id="gestaoId" />

    <e-drawer-visualizar-atendimento
      v-if="atendimentoVisualizado"
      v-model="drawerVisualizar"
      :atendimento="atendimentoVisualizado"
    />
  </main-template>
</template>

<script>
export default {
  props: {
    gestaoId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      gestao: null,
      atendimentos: [],
      carregando: false,
      pageNumber: 1,
      paginate: { current_page: 1, last_page: 1, total: 0 },
      table: {
        headers: [
          { text: "ID", value: "id" },
          { text: "Data", value: "data" },
          { text: "Situação", value: "situacao" },
          { text: "Tipo de Aula", value: "tipo_de_atendimento" },
          { text: "Horário", value: "horario" },
          { text: "", value: "actions", sortable: false, width: "180px" },
        ],
      },
      dialogMes: false,
      meses: [],
      mesSelecionado: null,
      totais: { confirmados: 0, aguardando: 0 },
      drawerHistorico: false,
      drawerVisualizar: false,
      atendimentoVisualizado: null,
    };
  },
  computed: {
    nomeDoAluno() {
      if (!this.gestao || !this.gestao.matricula) return "- - -";
      const { matricula } = this.gestao;
      return matricula.aluno ? matricula.aluno.nomecompleto : matricula.nomecompleto || "- - -";
    },
    // podeConfirmar() {
    //   return this.$can(["atendimentosAuxiliares.atualizarSituacao", "atendimentosAuxiliares.*"]);
    // },
  },
  async mounted() {
    await this.load();
  },
  methods: {
    // estaConfirmado(atendimento) {
    //   return atendimento.descricaoSituacao === "Aula confirmada";
    // },
    async load() {
      this.$loaderService.open("Carregando atendimentos...");
      try {
        this.gestao = await this.$services.gestoesDeAulasAuxiliaresService.visualizar(
          this.gestaoId
        );
        await this.listarAtendimentos(this.pageNumber);
        this.meses = await this.$services.anosService.meses();
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    async listarAtendimentos(pageNumber = 1) {
      this.carregando = true;
      try {
        const response = await this.$services.atendimentosAuxiliaresService.listar(
          this.gestaoId,
          pageNumber
        );
        this.atendimentos = response.data;
        this.paginate = response;
        this.totais = response.totais || { confirmados: 0, aguardando: 0 };
        this.pageNumber = pageNumber;
      } catch (error) {
        this.$handleError(error);
      }
      this.carregando = false;
    },
    criarAtendimento() {
      this.$router.push({
        name: "atendimentosAuxiliares.create",
        params: { gestaoId: this.gestaoId },
      });
    },
    editarAtendimento(atendimento) {
      this.$router.push({
        name: "atendimentosAuxiliares.edit",
        params: { gestaoId: this.gestaoId, atendimentoId: atendimento.id },
      });
    },
    // Espelha o Diário Online (Aulas/index.vue): editar só em 'Aguardando confirmação'
    // e 'em conflito'. O back repete a regra no AtendimentoAuxiliarRequest.
    podeEditar(atendimento) {
      return ["Aguardando confirmação", "Atendimento em conflito"].includes(
        atendimento.descricaoSituacao
      );
    },
    visualizarAtendimento(atendimento) {
      this.atendimentoVisualizado = atendimento;
      this.drawerVisualizar = true;
    },
    // async confirmarAtendimento(atendimento) {
    //   this.$loaderService.open("Confirmando atendimento...");
    //   try {
    //     await this.$services.atendimentosAuxiliaresService.alterarSituacao(
    //       this.gestaoId,
    //       atendimento.id,
    //       "Aula confirmada"
    //     );
    //     this.$toast.success("Atendimento confirmado");
    //     await this.listarAtendimentos(this.pageNumber);
    //   } catch (error) {
    //     this.$handleError(error);
    //   }
    //   this.$loaderService.close();
    // },
    apagarAtendimento(atendimento) {
      this.$modals.danger({
        title: "Cuidado!",
        message: "Tem certeza que deseja apagar este atendimento?",
        confirmationCode: atendimento.id,
        confirmationMessage: `Por favor, digite <strong>${atendimento.id}</strong> para confirmar`,
        buttons: [
          {
            text: "Cancelar",
            callback: () => this.$modals.close(),
            props: { color: "warning", small: true },
          },
          {
            text: "Confirmar",
            disableIfCodeDoesntMatch: true,
            callback: async () => {
              this.$modals.close();
              this.$loaderService.open("Apagando atendimento...");
              try {
                await this.$services.atendimentosAuxiliaresService.deletar(
                  this.gestaoId,
                  atendimento.id
                );
                this.$toast.success("Atendimento apagado com sucesso");
                await this.listarAtendimentos(this.pageNumber);
              } catch (error) {
                this.$handleError(error);
              }
              this.$loaderService.close();
            },
            props: { color: "error", small: true },
          },
        ],
      });
    },
    async gerarDocumentoDeAtendimentos() {
      this.dialogMes = false;
      this.$loaderService.open("Gerando documento...");
      try {
        await this.$services.atendimentosAuxiliaresService.documentoDeAtendimentos(
          this.gestaoId,
          this.mesSelecionado
        );
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    abrirHistorico() {
      this.drawerHistorico = true;
    },
  },
};
</script>
